export default "__VITE_ASSET__CgrIv3Lt__"